export enum ABTestStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum UserCountry {
  USA = 'usa',
  ITA = 'ita',
  MEA = 'mea',
  SPARTACUS = 'spartacus',
}

export interface ABExperimentVariant {
  id: string;
  name: string;
  percentage: number;
}

export interface ABExperiment {
  id: string;
  name: string;
  status: ABTestStatus;
  targetingConditions: {
    country: UserCountry[];
    segments: string[];
    customProperties: { prop: string; value: string }[];
  };
  enrollement: (variantID: string) => void;
  variants: ABExperimentVariant[];
}

export interface ABUserInfo {
  experiment: ABExperiment;
  selectedVariant: ABExperimentVariant;
}

export interface ABVariantComponent {
  variantId: string;
  component: React.ReactNode;
}
